import React from 'react'
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'
import 'antd/dist/reset.css'
import 'App.scss'
import { canAccess, getDefaultRoute } from 'config/permissions'
import useAuthStore from 'store/authStore'
import { RefreshAuth } from 'api/Auth'
// page báo cáo kinh doanh
// import Home from 'pages/BusinessReport'
import Home from 'pages/Dashboard'
import Login from 'pages/login'
import Register from 'pages/login/register'
import ForgotPasswordPage from 'pages/login/ForgotPasswordPage'
import Departments from 'pages/departments'
import Chats from 'pages/chats'
import CustomerTags from 'pages/CustomerTags'
import CareStatus from 'pages/CareStatus'
import Profession from 'pages/Profession'
import Customer from 'pages/Customer'
import CustomerDemo from 'pages/CustomerDemo'
import CustomerDemoDetail from 'pages/CustomerDetailsDemo'
import MarketingCampaignReport from 'pages/MarketingCampaignReport'
import CustomerDetail from 'pages/CustomerDetails'
import CreateOrder from 'pages/CreateOrder'
import ProductsCat from 'pages/ProductsCat'
import Products from 'pages/Products'
import ProductsAdd from 'pages/Products/Add'
import Warehouses from 'pages/Warehouses'
import Employee from 'pages/Employee'
import GroupRoles from 'pages/Roles/GroupRoles'
import AppointmentTransitions from 'pages/AppointmentTransitions'
import OverviewReport from 'pages/OverviewReport'
import PageReport from 'pages/PageReport'
import OrdersPage from 'pages/OrdersPage'
import ListOrder from 'pages/ListOrder/OrderTableDemo'
import OrderDetailPage from 'pages/ListOrder/OrderDetailPage'
import OrderCustomerDetail from 'pages/OrdersPage/CustomerDetail'
import OrderPageDetail from 'pages/OrdersPage/detail'
import RoomChat from 'pages/RoomChat'
import RealtimeDemo from 'pages/RealtimeDemo'
import QuickMessages from 'pages/QuickMessages'
import SaleOnlineReport from 'pages/SaleOnlineReport'
import BusinessReport from 'pages/BusinessReport'
import CustomerReport from 'pages/CustomerReport'
import HairClinicForm from 'pages/ChuyenMon/HairClinicForm'
import Advertise from 'pages/Advertise/'
import AdsDetail from 'pages/Advertise/AdsDetail'
import MikoReceptionPage from 'pages/ChuyenMon/MikoReceptionPage'
import CosmeticSurgeryReception from 'pages/ChuyenMon/CosmeticSurgeryReception'
import ThreadLiftReception from 'pages/ChuyenMon/ThreadLiftReception'
import ConsultationForm from 'pages/ChuyenMon/ConsultationForm'
import BeautyConsultation from 'pages/ChuyenMon/BeautyConsultation'
import ConsultationTabs from 'pages/ChuyenMon/ConsultationTabs'
import CustomerCM from 'pages/ChuyenMon/Customer'
import CustomerCMDetail from 'pages/ChuyenMon/CustomerDetail'
import CustomerExecution from 'pages/ChuyenMon/CustomerExecution'
import CustomerExecutionDetail from 'pages/ChuyenMon/CustomerExecutionDetail'
import Services from 'pages/Services'
import ServiceList from 'pages/ServiceList'
import BranchManager from 'pages/BranchManager'
import NotificationsPage from 'pages/Notifications'
import UnauthorizedPage from 'pages/Unauthorized'
import NotFoundPage from 'pages/NotFound'
import ProfilePage from 'pages/Admin/profile'
import CareList from 'pages/CareList'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MarketingReport from 'pages/MarketingReport'
import AdvertisingCampaign from 'pages/AdvertisingCampaign'
import AdvertisingCampaignManagement from 'pages/AdvertisingCampaignManagement'
import AppointmentSurvey from 'pages/AppointmentSurvey'
import FacebookCallbackStatus from 'pages/chats/FacebookCallbackStatus'
import TiktokCallbackStatus from 'pages/chats/TiktokCallbackStatus'
import TrucPageDashbroad from 'pages/TrucPageDashbroad'

const PROTECTED_STATIC_ROUTES = [
  '/',
  '/departments',
  '/chats',
  '/customer-tags',
  '/appointment-transitions',
  '/care-status',
  '/profession',
  '/customer',
  '/appointment/create',
  '/products-cat',
  '/products',
  '/product/add',
  '/warehouses',
  '/employee',
  '/group-roles',
  '/overview-report',
  '/page-report',
  '/orders',
  '/quick-messages',
  '/hair-clinic',
  '/advertise',
  '/advertise/detail',
  '/miko-reception',
  '/cosmetic-surgery-reception',
  '/thread-lift-reception',
  '/consultation-form',
  '/beauty-consultation',
  '/consultation-tabs',
  '/sale-online-report',
  '/business-report',
  '/customer-report',
  '/consultations',
  '/execution-schedule',
  '/services',
  '/services-list',
  '/branch-manager',
];

function getFirstAuthorizedRoute(permissions: string[], isSuperAdmin: boolean): string | null {
  const defaultRoute = getDefaultRoute(permissions, isSuperAdmin);
  if (defaultRoute !== '/unauthorized' && canAccess(defaultRoute, permissions, isSuperAdmin)) {
    return defaultRoute;
  }

  for (const route of PROTECTED_STATIC_ROUTES) {
    if (route !== '/unauthorized' && canAccess(route, permissions, isSuperAdmin)) {
      return route;
    }
  }

  return null;
}

function PrivateRoute() {
  const token = localStorage.getItem('token');
  return token ? <Outlet /> : <Navigate to="/login" replace />;
}

/**
 * Bảo vệ route dựa trên permissions (data.info.role.permissions).
 * Super admin (type === 1) toàn quyền, bỏ qua check permissions.
 */
function PermissionRoute() {
  const { permissions, isSuperAdmin, type } = useAuthStore();
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (!token) return <Navigate to="/login" replace />;

  // Cho phép vào trang thông báo để tránh vòng lặp redirect.
  if (location.pathname === '/unauthorized') return <Outlet />;

  if (type === null) {
    return <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />;
  }

  if (!canAccess(location.pathname, permissions, isSuperAdmin)) {
    if (location.pathname === '/') {
      const authorizedRoute = getFirstAuthorizedRoute(permissions, isSuperAdmin);
      if (authorizedRoute) {
        return <Navigate to={authorizedRoute} replace />;
      }
    }
    return <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

const App: React.FC = () => {
  // Đồng bộ lại quyền của nhân viên đang đăng nhập với backend khi:
  //   - App mount (mở tab / F5)
  //   - Tab được focus lại sau khi rời đi
  // Tránh việc admin đổi nhóm quyền nhưng client vẫn dùng cache cũ trong localStorage.
  React.useEffect(() => {
    const sync = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      const res = await RefreshAuth();
      if (res.ok) {
        useAuthStore.getState().setAuth(res.type ?? null, res.permissions ?? []);
      }
    };
    sync();
    const onFocus = () => { sync(); };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/forgot-password' element={<ForgotPasswordPage />} />
        {/* Khách hàng tự đánh giá sau dịch vụ — không yêu cầu đăng nhập */}
        <Route path='/khao-sat/:id' element={<AppointmentSurvey />} />
        {/* Facebook OAuth redirect về đây (FACEBOOK_FRONTEND_CALLBACK_URL) — mở trong popup,
            để ngoài PermissionRoute để không bị đá về /login hay /unauthorized */}
        <Route path='/facebook/callback-status' element={<FacebookCallbackStatus />} />
        {/* TikTok Business OAuth redirect ve day (TIKTOK_FRONTEND_CALLBACK_URL) */}
        <Route path='/tiktok/callback' element={<TiktokCallbackStatus />} />

        {/* Protected routes */}
        <Route element={<PermissionRoute />}>
          <Route path='/' element={<Home />} />
          <Route path='/departments' element={<Departments />} />
          <Route path='/chats' element={<Chats />} />
          <Route path='/customer-tags' element={<CustomerTags />} />
          <Route path='/appointment-transitions' element={<AppointmentTransitions />} />
          <Route path='/care-status' element={<CareStatus />} />
          <Route path='/profession' element={<Profession />} />
          <Route path='/customer' element={<Customer />} />
          <Route path='/customer-demo' element={<CustomerDemo />} />
          <Route path='/customer-demo/detail' element={<CustomerDemoDetail />} />
          <Route path='/customer/:id' element={<CustomerDetail />} />
          <Route path='/appointment/create' element={<CreateOrder />} />
          <Route path='/products-cat' element={<ProductsCat />} />
          <Route path='/products' element={<Products />} />
          <Route path='/product/add' element={<ProductsAdd />} />
          <Route path='/warehouses' element={<Warehouses />} />
          <Route path='/employee' element={<Employee />} />
          <Route path='/group-roles' element={<GroupRoles />} />
          <Route path='/overview-report' element={<OverviewReport />} />
          <Route path='/page-report' element={<PageReport />} />
          <Route path='/appointments' element={<OrdersPage />} />
          <Route path='/appointment/detail/:id' element={<OrderCustomerDetail />} />
          <Route path='/appointment/:id' element={<OrderPageDetail />} />
          <Route path='/chat/:id' element={<RoomChat />} />
          <Route path='/realtime-demo' element={<RealtimeDemo />} />
          <Route path='/notifications' element={<NotificationsPage />} />
          <Route path='/quick-messages' element={<QuickMessages />} />
          <Route path='/hair-clinic' element={<HairClinicForm />} />
          <Route path='/advertise' element={<Advertise />} />
          <Route path='/advertise/detail' element={<AdsDetail />} />
          <Route path='/miko-reception' element={<MikoReceptionPage />} />
          <Route path='/cosmetic-surgery-reception' element={<CosmeticSurgeryReception />} />
          <Route path='/thread-lift-reception' element={<ThreadLiftReception />} />
          <Route path='/consultation-form' element={<ConsultationForm />} />
          <Route path='/beauty-consultation' element={<BeautyConsultation />} />
          <Route path='/consultation-tabs' element={<ConsultationTabs />} />
          <Route path='/sale-online-report' element={<SaleOnlineReport />} />
          <Route path='/business-report' element={<BusinessReport />} />
          <Route path='/customer-report' element={<CustomerReport />} />
          <Route path='/consultations' element={<CustomerCM />} />
          <Route path='/consultation/detail/:id' element={<CustomerCMDetail />} />
          <Route path='/execution-schedule' element={<CustomerExecution />} />
          <Route path='/execution-schedule/detail/:id' element={<CustomerExecutionDetail />} />
          <Route path='/services' element={<Services />} />
          <Route path='/services-list' element={<ServiceList />} />
          <Route path='/branch-manager' element={<BranchManager />} />
          <Route path='/list-order' element={<ListOrder />} />
          <Route path='/order-detail' element={<OrderDetailPage />} />
          <Route path='/care-list' element={<CareList />} />
          <Route path='/marketing-report' element={<MarketingReport />} />
          <Route path='/advertising-campaign' element={<AdvertisingCampaign />} />
          <Route path='/marketing-campaign-report' element={<MarketingCampaignReport />} />
          <Route path='/advertising-campaign-management' element={<AdvertisingCampaignManagement />} />
          <Route path='/admin/profile' element={<ProfilePage />} />
          <Route path='/unauthorized' element={<UnauthorizedPage />} />
          <Route path='/dashbroad-truc-page' element={<TrucPageDashbroad />} />
        </Route>

        <Route path='*' element={<NotFoundPage />} />
      </Routes >
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  )
}

export default App
